import {createStore, applyMiddleware} from 'redux'
import ReduxThunk from 'redux-thunk'
import TimelineReducers from './timeline/reducers'

export default createStore(TimelineReducers, undefined, applyMiddleware(ReduxThunk))